export default __webpack_public_path__ + "static/media/floydhub.9439b66a.svg";